import { Environment } from '../../types';
import { getLoginUrl } from './loginUrl';

export const getRedirectUrl = (
  env: Environment,
  referralUrl: string
): string => {
  const loginPortalUrl = getLoginUrl(env);
  return `${loginPortalUrl}?referral=${referralUrl}`;
};
